"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var nucleus_1 = require("@lifesize/nucleus");
var constants_1 = require("../constants");
var redux_1 = require("../utils/redux");
var get_1 = __importDefault(require("lodash/get"));
var GALAXY_ACTION_END = nucleus_1.nucleusConstants.GALAXY_ACTION_END;
/** @module state/nucleus/app */
/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
exports.initialState = {
    isInCallPipVisible: true,
    isPipPreviewVisible: false,
    isPresentationPromptVisible: false,
    volume: 0.5,
    isLegacyServiceDegraded: false,
    sipIncomingCall: null,
    sipActiveCall: null,
    inCallLayout: '',
    meetingStartPromptVisible: false,
    raiseHandErrors: [],
    selectedParticipant: null
};
/**
 * Stores 'app' related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- app
 *       +-- isBackgrounded: bool
 * @example
 * store
 * +-- nucleus
 *     +-- app
 *       +-- isBackgrounded: false
 *       +-- sipIncomingCall
 *          +-- { id: '123', canAnswer: true, canAdd: false, canEndAndAnswer: false, dialString: '123@sip.com', displayString: 'Bob' }
 *       +-- sipActiveCall
 *          +-- { id: '123', state: 'connectected', dialString: '123@sip.com', displayString: 'Bob', startTime: int, endTime: int, .. }
 */
exports.default = redux_1.createReducer(exports.initialState, (_a = {},
    _a[constants_1.app.actions.togglePresentationPrompt] = function (state, action) {
        return __assign(__assign({}, state), { isPresentationPromptVisible: get_1.default(action, 'payload') === null ? !state.isPresentationPromptVisible : action.payload });
    },
    _a[constants_1.app.actions.toggleInCallPip] = function (state, action) {
        // If a payload is present, then assign the new value to match the payload, otherwise toggle the pip
        return __assign(__assign({}, state), { isInCallPipVisible: get_1.default(action, 'payload') === null ? !state.isInCallPipVisible : action.payload });
    },
    _a[constants_1.app.actions.togglePipPreview] = function (state, action) {
        // If a payload is present, then assign the new value to match the payload, otherwise toggle the pip preview
        return __assign(__assign({}, state), { isPipPreviewVisible: get_1.default(action, 'payload') === null ? !state.isPipPreviewVisible : action.payload });
    },
    _a[constants_1.app.actions.changeVolumeInCall] = function (state, action) {
        return __assign(__assign({}, state), { volume: get_1.default(action, 'payload') });
    },
    _a[constants_1.app.actions.setIsLegacyServiceDegraded] = function (state, action) { return (__assign(__assign({}, state), { isLegacyServiceDegraded: get_1.default(action, 'payload') })); },
    _a[constants_1.app.actions.setSipIncomingCall] = function (state, action) { return (__assign(__assign({}, state), { sipIncomingCall: get_1.default(action, 'payload') })); },
    _a[constants_1.app.actions.setSipActiveCall] = function (state, action) { return (__assign(__assign({}, state), { sipActiveCall: get_1.default(action, 'payload') })); },
    _a[constants_1.app.actions.selectCallLayout] = function (state, action) { return (__assign(__assign({}, state), { inCallLayout: get_1.default(action, 'payload') })); },
    _a[constants_1.app.actions.showMeetingStartPrompt] = function (state, action) { return (__assign(__assign({}, state), { meetingStartPromptVisible: get_1.default(action, 'payload.meetingStartPromptVisible') })); },
    _a[constants_1.app.actions.setRaiseHandErrors] = function (state, action) {
        var error = get_1.default(action, 'payload');
        var raiseHandErrors = error ? state.raiseHandErrors.concat(error) : state.raiseHandErrors;
        return __assign(__assign({}, state), { raiseHandErrors: raiseHandErrors });
    },
    _a[constants_1.app.actions.clearRaiseHandErrors] = function (state) { return (__assign(__assign({}, state), { raiseHandErrors: [] })); },
    // Note: Stores the updated selected participant object with selected states, so it can be sent back to the RCA.
    // Also clears the selected participant when call ends.
    _a[constants_1.app.actions.selectParticipant] = function (state, action) { return (__assign(__assign({}, state), { selectedParticipant: get_1.default(action, 'payload') })); },
    _a[GALAXY_ACTION_END] = function (state) { return (__assign(__assign({}, state), { selectedParticipant: null })); },
    _a));
